module.exports = __webpack_public_path__ + "static/media/blog15.8c0811e1.svg";